export { computePayload } from './cars';
export { computePayloadEbike } from './ebikes';
